import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96e0fecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-card_user-data" }
const _hoisted_2 = { class: "task-card_hidden-users" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  key: 1,
  class: "task-card_absence-elements"
}

import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { UserCircleIcon } from 'tir-style-system/icons/outline';
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmScrollbar,
  TirPmTooltipElement,
} from 'tir-components';
import { TaskModel, TaskPersonModel } from '../../../../../pages/monitorings/models';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-performers',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
  /**Таблица мониторинга тикетов */
  monitoringTicketPage: { type: Boolean, default: false },
  /**Отображать исполнителей в левой части таблицы */
  isPerformersLeftBlock: { type: Boolean, default: false },
  /**Скрыть правый блок с исполнителями */
  hiddenPersonsRightBlock: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



/**Кол-во срезаемых элементов */
const countSlicePersons = props.hiddenPersonsRightBlock ? 4 : 2;
/**Показанные исполнители */
const shownPersons = computed<TaskPersonModel[]>(() => {
  const persons = props.task.Performers.slice(0, countSlicePersons);
  const uniqueIds = Array.from(new Set(persons.map((p) => p.Id)));
  const personsToShow = [];
  uniqueIds.forEach((id) => {
    personsToShow.push(persons.find((p) => p.Id == id));
  });
  return personsToShow;
});
/**Скрытые исполнители */
const hiddenPersons = computed<TaskPersonModel[]>(() =>
  props.task.Performers.slice(countSlicePersons),
);

return (_ctx: any,_cache: any) => {
  return (!__props.isPerformersLeftBlock)
    ? (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), {
        key: 0,
        element: __props.element,
        class: _normalizeClass({ 'task-card_block': __props.monitoringTicketPage })
      }, {
        default: _withCtx(() => [
          (props.task.Performers.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.isPerformersLeftBlock)
                  ? (_openBlock(), _createBlock(_unref(UserCircleIcon), {
                      key: 0,
                      class: "task-card_icon"
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shownPersons.value, (person) => {
                  return (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
                    key: person.Id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TirPmIconView), {
                        "is-rounded": "",
                        size: 24,
                        imageLoadUrl: person.ImageUrl,
                        colorCode: person.NoPhotoColor,
                        "is-bordered": false
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(person.FirstName[0] + person.LastName[0]), 1)
                        ]),
                        _: 2
                      }, 1032, ["imageLoadUrl", "colorCode"])
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(person.LastName) + " " + _toDisplayString(person.FirstName) + " " + _toDisplayString(person.MiddleName), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(TirPmPopover), {
                    isHideTriangle: false,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
                  }, {
                    default: _withCtx(() => [
                      (hiddenPersons.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            textContent: _toDisplayString(`+${hiddenPersons.value.length}`),
                            class: "task-card_circle"
                          }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                    ]),
                    content: _withCtx(() => [
                      _createVNode(_unref(TirPmScrollbar), {
                        class: "task-card_scrollbar",
                        "show-on-hover": true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hiddenPersons.value, (person) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: person.Id,
                              class: "task-card_hidden-users-content"
                            }, [
                              _createVNode(_unref(TirPmIconView), {
                                "is-rounded": "",
                                size: 24,
                                imageLoadUrl: person.ImageUrl,
                                colorCode: person.NoPhotoColor,
                                "is-bordered": false
                              }, {
                                mainSlot: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(person.FirstName[0] + person.LastName[0]), 1)
                                ]),
                                _: 2
                              }, 1032, ["imageLoadUrl", "colorCode"]),
                              _createTextVNode(" " + _toDisplayString(person.LastName) + " " + _toDisplayString(person.FirstName) + " " + _toDisplayString(person.MiddleName), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, "-"))
        ]),
        _: 1
      }, 8, ["element", "class"]))
    : _createCommentVNode("", true)
}
}

})